import type { Middleware } from 'types/redux'
import { MIXPANEL } from '@disco/constants/AnalyticsEventTypes'

const mixpanelExtender: Middleware =
  (store: Record<string, any>) =>
  (next: (...args: Array<any>) => any) =>
  (action: Record<string, any>) => {
    try {
      const businessId = store.getState()?.user?.business?.id

      if (action.meta?.[MIXPANEL]?.event) {
        next({
          ...action,
          meta: {
            ...action.meta,
            [MIXPANEL]: {
              ...action.meta[MIXPANEL],
              props: {
                ...action.meta[MIXPANEL].props,
                business_id: businessId,
              },
            },
          },
        })
      } else {
        return next(action)
      }
    } catch {
      return next(action)
    }
  }

export default mixpanelExtender
